export const Common = {
    Font: {
        normalText: 'normal normal 14px Lato',
    },
    Color: {
        buttonBackground: '#368cd7',
        lightTextColor: '#ffffff',
        greenColor: '#0eb075',
        cardBorder: '#DFE2E5',
        background: '#EFF3F6',
        lightGray: '#A9A9A9',
        red: '#FF3457',
    },
    Borders: {
        boxShadowHover: '0 0 4px 0 rgba(0, 0, 0, 0.2)',
        border: 'solid 1px #d4d4d4',
        radius: '4px',
        radiusLarge: '5px',
    },
    Dimensions: {
        normalHeight: '40px',
        controlWidth: '100%',
        minControlWidth: '150px',
        maxControlWidth: '350px'
    },
    disabled: {
        cursor: 'not-allowed',
        color: '#7e7e7e',
    },
    padding: {
        tiny: '16px',
        small: '24px',
        default: '32px',
        big: '40px',
        huge: '80px'
    }
};
